import { PaginatorService } from 'src/app/services/paginator.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { OcorrenciaTipo } from '../../models/ocorrencia-tipo';
import { OcorrenciaHistorico } from '../../models/ocorrencia-historico';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CarregandoService } from '../../services/carregando.service';
import { NotificacaoService } from '../../services/notificacao.service';
import { OcorrenciaService } from '../../services/ocorrencia.service';
import { Ocorrencia } from '../../models/ocorrencia';
import { StatusDaOcorrencia, TipoArquivo, EtapaDoPedido, PerfilDoUsuario } from '../../models/enum';
import { OcorrenciaHistoricoService } from '../../services/ocorrencia-historico.service';
import { OcorrenciaAnexoService } from '../../services/ocorrencia-anexo.service';
import { OcorrenciaAnexo } from '../../models/ocorrencia-anexo';
import { ArquivoService } from '../../services/arquivo.service';
import { UtilitarioService } from '../../services/utilitario.service';
import swal from 'sweetalert2';
import { Pedido } from 'src/app/models/pedido';
import { EtapaService } from 'src/app/services/etapa.service';
import { Etapa } from 'src/app/models/etapa';
import { PedidoService } from 'src/app/services/pedido.service';
import { MatDialog, MatPaginator, PageEvent } from '@angular/material';
import { ResumoModalComponent } from 'src/app/modals/resumo-modal/resumo-modal.component';
import { UsuarioLogado } from 'src/app/models/usuario-logado';
import { GlobalService } from 'src/app/services/global.service';
import { NotaFiscalPedidoModalComponent } from 'src/app/modals/nota-fiscal-pedido-modal/nota-fiscal-pedido-modal.component';
import { NotaFiscalService } from 'src/app/services/nota-fiscal.service';
import { OcorrenciaLogRespModalComponent } from 'src/app/modals/ocorrencia-log-resp-modal/ocorrencia-log-resp-modal.component';
import { CRMHierarquiaUsuario } from 'src/app/models/crmhierarquia-usuario';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { LogOcorrenciaComponent } from 'src/app/modals/log-ocorrencia-modal/log-ocorrencia-modal.component';
import { EtapaOcorrencia } from 'src/app/models/etapa-ocorrencia';
import { LogEtapaOcorrenciaModalComponent } from 'src/app/modals/log-etapa-ocorrencia-modal/log-etapa-ocorrencia-modal.component';
import { SetorService } from 'src/app/services/setor.service';
import { NotaFiscalOcorrencia } from 'src/app/models/nota-fiscal-ocorrencia';
import { PremissasSistema } from 'src/app/models/premissas-sistema';
import { PremissasService } from 'src/app/services/premissas.service';
import { CadastrarNotaFiscalPedidoModalComponent } from 'src/app/modals/nota-fiscal-pedido-modal/cadastrar-nota-fiscal-pedido-modal/cadastrar-nota-fiscal-pedido-modal.component';

declare const $: any;

@Component({
  selector: 'app-lancamento-controle-ocorrencia',
  templateUrl: './lancamento-controle-ocorrencia.component.html',
  styleUrls: ['./lancamento-controle-ocorrencia.component.scss']
})
export class LancamentoControleOcorrenciaComponent implements OnInit {
  administrador = true;
  ocorrenciatipo: OcorrenciaTipo[] = [];
  historico: OcorrenciaHistorico[] = [];
  anexos: OcorrenciaAnexo[] = [];

  enumStatus = [
    { id: 0, name: 'Novo' },
    { id: 1, name: 'Em Andamento' },
    { id: 2, name: 'Concluido' }
  ];

  statusSelecionado: StatusDaOcorrencia;
  files: File[] = [];
  ocorrencia: Ocorrencia = new Ocorrencia();
  idOcorrencia: number;
  veioDoModal: boolean;
  novaMensagem = '';

  imagens: OcorrenciaAnexo[] = [];
  documentos: OcorrenciaAnexo[] = [];

  etapas: Etapa[] = [];

  pedido: Pedido = new Pedido();

  usuarioLogado: UsuarioLogado = new UsuarioLogado();

  items: any[] = [];
  public htmlCode: string;
  public htmlDoc: HTMLElement;

  public mentionConfig = {
    labelKey: 'nome',
    dropUp: true,
    mentionSelect: (e: any) => {
      return '##' + e.nome + '##';
    }
  };
  historicoCitados: number[] = [];

  visibilidade = {
    resumo: false,
    resumoFinanceiro: false,
    editar: false,
    aprovar: false,
    reprovar: false,
    separar: false,
    despachar: false,
    entregar: false,
    verJustificativa: false,
    vincularNota: false,
    imprimirNota: false,
    conferir: false,
    anexos: false,
    faturar: false,
    integrar: false,
    aguardarValidacao: false,
    aguardarIntegracao: false,
    verRecebimentos: false,
    podeEditarRecebimentos: false,
    tagsDoPedido: true
  };

  navigationSubscription;

  vendedor = false;

  existeLog = false;
  etapasOcorrencia: EtapaOcorrencia[] = [];
  etapaOcorrenciaSelecionada;
  setor = '';

  notasFiscaisOcorrencia: NotaFiscalOcorrencia[] = [];
  editandoNota: boolean = false;
  premissasSistema = new PremissasSistema();
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina = 10;
  campoOrdenacao = 'id';
  ordenarDesc = false;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private ocorrenciaService: OcorrenciaService,
    private ocorrenciaHistoricoService: OcorrenciaHistoricoService,
    private ocorrenciaAnexoService: OcorrenciaAnexoService,
    private arquivoService: ArquivoService,
    private utilitarioService: UtilitarioService,
    private etapaService: EtapaService,
    private pedidoService: PedidoService,
    private dialog: MatDialog,
    private globalService: GlobalService,
    private notaFiscalService: NotaFiscalService,
    private funcionarioService: FuncionarioService,
    private setorService: SetorService,
    private premissasService: PremissasService,
    private paginatorService: PaginatorService
  ) {
    if (!this.router.getCurrentNavigation().extras.state) {
      this.router.navigate(['/dashboard']);
    } else {
      this.veioDoModal = this.router.getCurrentNavigation().extras.state.veioDoModal;
      this.idOcorrencia = this.router.getCurrentNavigation().extras.state.idOcorrencia;
    }
  }

  async ngOnInit(): Promise<void> {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.usuarioLogado = await this.globalService.consultaUsuario();

    if (this.veioDoModal) {
      this.vendedor = (await this.globalService.perfil()) === PerfilDoUsuario.Vendedor;
    }

    this.administrador = await this.globalService.administrador();

    await this.buscarOcorrencia();
    await this.buscarPedido();
    await this.buscarEtapas();

    this.buscarPremissasSistema();

    this.buscarVendedores();

    this.buscarHistorico();
    this.buscarAnexos();
    this.buscarEtapasOcorrencia();
    this.buscarSetor();

    this.etapaOcorrenciaSelecionada = this.ocorrencia.idEtapa;
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra('buscarPremissasSistema');

    this.premissasService.consultarPremissasSistema().subscribe(
      (premissas) => {
        this.premissasSistema = premissas;

        if (this.premissasSistema.verNotasFiscaisOcorrencia) {
          this.buscarNotasOcorrencia();
        }

        this.carregandoService.esconde('buscarPremissasSistema');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissasSistema');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarEtapasOcorrencia() {
    this.carregandoService.mostra('buscarEtapasOcorrencia');
    this.ocorrenciaService.consultarEtapas(this.ocorrencia.idSetor, this.ocorrencia.idTipoOcorrencia).subscribe(
      (data: any) => {
        this.etapasOcorrencia = data;
        this.carregandoService.esconde('buscarEtapasOcorrencia');
      },
      (erro) => {
        this.carregandoService.esconde('buscarEtapasOcorrencia');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarSetor() {
    this.carregandoService.mostra('buscarSetor');

    this.setorService.consultarPorIdSetor(this.ocorrencia.idSetor).subscribe(
      (data: any) => {
        this.setor = data.descricao;
        this.carregandoService.esconde('buscarSetor');
      },
      (erro) => {
        this.carregandoService.esconde('buscarSetor');
        console.log(erro);
      }
    );
  }

  buscarVendedores() {
    this.carregandoService.mostra('buscarVendedores');

    this.funcionarioService.consultarFuncionarioPorIdCupom(this.ocorrencia.idCupom).subscribe(
      (dados) => {
        this.items = dados;
        this.carregandoService.esconde('buscarVendedores');
      },
      (erro) => {
        this.carregandoService.esconde('buscarVendedores');
        this.notificacaoService.erro(erro);
      }
    );
  }

  editarOcorrencia() {
    this.router.navigateByUrl('/controle-ocorrencia/editar/' + this.ocorrencia.id);
  }

  retornaClasseStatus(status: number) {
    if (status === null || status === undefined) return;
    switch (status.toString()) {
      case '0':
        return 'badge-primary';
      case '1':
        return 'badge-info';
      case '2':
        return 'badge-success';

      default:
        return 'badge-info';
    }
  }

  onChangeStatus() {
    const descricaoStatus = this.enumStatus.find((p) => p.id === this.statusSelecionado).name;

    swal({
      title: 'Atenção!!',
      html: 'Deseja mesmo alterar o status para <span class="font-weight-bold">' + descricaoStatus + '</span>?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.esconde('alterarStatus');

        this.ocorrenciaService.alterarStatus(this.idOcorrencia, this.statusSelecionado).subscribe(
          () => {
            this.ocorrencia.status = this.statusSelecionado;
            this.ocorrencia.statusDescricao = descricaoStatus;
            this.buscarOcorrencia();

            this.carregandoService.esconde('alterarStatus');
          },
          (erro) => {
            switch (erro.status) {
              case 400:
                this.notificacaoService.erro(erro);
              case 409:
                this.ocorrencia.status = this.statusSelecionado;
                this.ocorrencia.statusDescricao = descricaoStatus;
                this.notificacaoService.aviso(erro);
            }
            this.carregandoService.esconde('alterarStatus');
          }
        );
      } else {
        this.carregandoService.esconde('alterarStatus');
        this.statusSelecionado = this.ocorrencia.status;
      }
    });
  }

  onChangeEtapasOcorrencia() {
    const descricaoEtapa = this.etapasOcorrencia.find((p) => p.id === this.etapaOcorrenciaSelecionada).descricao;

    swal({
      title: 'Atenção!!',
      html: 'Deseja mesmo alterar a etapa para <span class="font-weight-bold">' + descricaoEtapa + '</span>?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.esconde('alterarEtapa');

        this.ocorrenciaService.alterarEtapa(this.idOcorrencia, this.etapaOcorrenciaSelecionada).subscribe(
          () => {
            this.ocorrencia.idEtapa = this.etapaOcorrenciaSelecionada;
            this.ocorrencia.nomeEtapa = descricaoEtapa;
            this.carregandoService.esconde('alterarEtapa');
          },
          (erro) => {
            switch (erro.status) {
              case 400:
                this.notificacaoService.erro(erro);
              case 409:
                this.ocorrencia.idEtapa = this.etapaOcorrenciaSelecionada;
                this.ocorrencia.nomeEtapa = descricaoEtapa;
                this.notificacaoService.aviso(erro);
            }
            this.carregandoService.esconde('alterarEtapa');
          }
        );
      } else {
        this.carregandoService.esconde('alterarEtapa');
        this.etapaOcorrenciaSelecionada = this.ocorrencia.idEtapa;
      }
    });
  }

  buscarOcorrencia() {
    this.carregandoService.mostra('buscarOcorrencia');

    return new Promise((resolve, reject) => {
      this.ocorrenciaService.consultarPorId(Number(this.idOcorrencia)).subscribe(
        (ocorrencia) => {
          this.ocorrencia = ocorrencia;

          this.statusSelecionado = ocorrencia.status;
          this.etapaOcorrenciaSelecionada = ocorrencia.idEtapa;
          this.ocorrencia.statusDescricao = this.enumStatus.find((p) => p.id === this.statusSelecionado).name;

          this.verificarSeExisteLog(this.ocorrencia.id);

          this.carregandoService.esconde('buscarOcorrencia');
          resolve();
        },
        (erro) => {
          this.carregandoService.esconde('buscarOcorrencia');
          this.notificacaoService.erro(erro);
          reject();
        }
      );
    });
  }

  buscarHistorico() {
    this.carregandoService.mostra('buscarHistorico');

    this.ocorrenciaHistoricoService.consultarPorIdOcorrencia(Number(this.idOcorrencia)).subscribe(
      (historico) => {
        this.historico = historico;
        this.carregandoService.esconde('buscarHistorico');
      },
      (erro) => {
        this.carregandoService.esconde('buscarHistorico');
        this.notificacaoService.erro(erro);
      }
    );
  }

  itemSelected(event: any) {
    this.historicoCitados.push(event.idFuncion);
    setTimeout(() => {
      this.htmlDoc = document.getElementById('novo-historico');
      this.htmlDoc.innerHTML = this.htmlDoc.innerHTML.replace(
        '##' + event.nome + '##',
        ' <b data-id=' + event.idFuncion + ' class="mention-user">@' + event.nome + '</b>&nbsp;'
      );
      // put the cursor to the end of field again...
      this.selectEnd();
    }, 10);
  }

  selectEnd() {
    let range, selection;
    range = document.createRange();
    range.selectNodeContents(this.htmlDoc);
    range.collapse(false);
    selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  }

  validarNovoHistorico() {
    this.htmlDoc = document.getElementById('novo-historico');

    return this.htmlDoc.innerHTML !== '';
  }

  gerarHistorico() {
    setTimeout(() => {
      this.htmlDoc = document.getElementById('novo-historico');

      if (this.htmlDoc.innerHTML === '') return;

      this.historicoCitados = [...new Set(this.historicoCitados)];

      this.historicoCitados.forEach((element) => {
        if (!this.htmlDoc.innerHTML.includes('data-id="' + element + '"')) {
          this.historicoCitados = this.historicoCitados.filter(function (item) {
            return item !== element;
          });
        }
      });

      const citadosIncorretamente = this.items.filter(
        (p) =>
          this.htmlDoc.innerHTML.includes('@' + p.nome) &&
          !this.htmlDoc.innerHTML.includes('data-id="' + p.idFuncion + '"')
      );

      if (citadosIncorretamente !== null && citadosIncorretamente !== undefined && citadosIncorretamente.length > 0) {
        swal({
          title: 'ATENÇÃO!!!',
          html: 'Existem usuários citados incorretamente:<br>' + citadosIncorretamente.map((p) => p.nome).join('<br>'),
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-warning',
          type: 'warning'
        }).catch(swal.noop);
      } else {
        this.salvarHistorico(this.htmlDoc.innerHTML);
      }
    }, 10);

    // ;
  }

  salvarHistorico(mensagem) {
    this.carregandoService.mostra('salvarHistorico');

    const novoHistorico = new OcorrenciaHistorico();
    novoHistorico.idOcorrencia = this.idOcorrencia;
    novoHistorico.texto = mensagem;
    novoHistorico.usuarios = this.historicoCitados;

    this.ocorrenciaHistoricoService.salvar(novoHistorico).subscribe(
      (result) => {
        this.novaMensagem = '';
        this.buscarHistorico();
        setTimeout(() => {
          this.htmlDoc = document.getElementById('novo-historico');
          this.htmlDoc.innerHTML = '';
        }, 10);
        this.carregandoService.esconde('salvarHistorico');
      },
      (erro) => {
        this.carregandoService.esconde('salvarHistorico');
        this.notificacaoService.erro(erro);
      }
    );
  }

  atualizarOpcoes() {
    this.carregandoService.mostra('atualizarOpcoes');

    this.ocorrenciaService.atualizarOpcoes(this.ocorrencia).subscribe(
      (result) => {
        this.carregandoService.esconde('atualizarOpcoes');
      },
      (erro) => {
        this.carregandoService.esconde('atualizarOpcoes');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarAnexos() {
    this.carregandoService.mostra('buscarAnexos');

    this.ocorrenciaAnexoService.consultarPorIdOcorrencia(Number(this.idOcorrencia)).subscribe(
      (anexos) => {
        this.anexos.push(anexos.filter((p) => !this.anexos.some((a) => a.id === p.id)));

        this.anexos = anexos;

        this.organizaAnexos();

        this.imagens.forEach((anexo) => {
          if (!anexo.buscouImagem) {
            anexo.imagem$ = this.arquivoService
              .baixarArquivo(anexo.id, TipoArquivo.Ocorrencia)
              .map((m) => this.utilitarioService.toBase64ComInicio(m))
              .toPromise();
            anexo.imagem$.then((p) => {
              anexo.buscouImagem = true;
            });
          }
        });

        this.carregandoService.esconde('buscarAnexos');
      },
      (erro) => {
        this.carregandoService.esconde('buscarAnexos');
        this.notificacaoService.erro(erro);
      }
    );
  }

  organizaAnexos() {
    this.imagens = this.anexos.filter(
      (p) =>
        !p.statusExc &&
        !p.arquivo.toLowerCase().endsWith('.pdf') &&
        !p.arquivo.toLowerCase().endsWith('.doc') &&
        !p.arquivo.toLowerCase().endsWith('.docx')
    );

    this.documentos = this.anexos.filter(
      (p) =>
        !p.statusExc &&
        (p.arquivo.toLowerCase().endsWith('.pdf') ||
          p.arquivo.toLowerCase().endsWith('.doc') ||
          p.arquivo.toLowerCase().endsWith('.docx'))
    );
  }

  excluirAnexo(anexo) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Anexo?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirAnexo');

        this.ocorrenciaAnexoService.excluir(anexo.id).subscribe(
          (result) => {
            this.anexos.splice(this.anexos.indexOf(anexo), 1);

            this.organizaAnexos();

            this.carregandoService.esconde('excluirAnexo');
          },
          (erro) => {
            this.carregandoService.esconde('excluirAnexo');
            this.notificacaoService.erro(erro);
          }
        );
      }
    });
  }

  salvarAnexos(arquivos: File[]) {
    this.carregandoService.mostra('salvarAnexo');
    const dados = new FormData();

    arquivos.forEach((item, index, arr) => {
      dados.append('arquivo_' + index, item);
    });

    this.ocorrenciaAnexoService.salvar(this.idOcorrencia, dados).subscribe(
      (result) => {
        this.buscarAnexos();
        this.carregandoService.esconde('salvarAnexo');
      },
      (erro) => {
        this.carregandoService.esconde('salvarAnexo');
        this.notificacaoService.erro(erro);
      }
    );
  }

  mostrarPreview(anexo: OcorrenciaAnexo) {
    anexo.imagem$.then((img) => {
      this.utilitarioService.mostrarImagemBase64(img, anexo.descricao);
    });
  }

  onSelect(event) {
    this.files.push(...event.addedFiles);

    this.salvarAnexos(event.addedFiles);
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  resumoDoPedido(pedido: Pedido) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(ResumoModalComponent, {
      width: $('body').width().toString() + 'px',
      data: {
        idCupom: pedido.idCupom,
        somenteLeitura: true,
        ocultarValores: true,
        mostrarDescontoItens: false,
        exibirConcordarTermos: false,
        mostrarResumoFinanceiro: this.visibilidade.resumoFinanceiro,
        mostrarRecebimentos: this.visibilidade.verRecebimentos,
        podeEditarRecebimentos: this.visibilidade.podeEditarRecebimentos,
        mostrarPrevisaoEntrega: this.visibilidade.entregar,
        tipo: 10 // this.pedido.ordemEtapa,
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
    });
  }

  logResp() {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(OcorrenciaLogRespModalComponent, {
      width: $('body').width().toString() + 'px',
      data: {
        idOcorrencia: this.ocorrencia.id,
        numeroOcorrencia: ('0000000' + this.ocorrencia.id).slice(-7)
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
    });
  }

  defineVisibilidade() {
    this.visibilidade.despachar = false;
    this.visibilidade.entregar = false;
    this.visibilidade.separar = false;
    this.visibilidade.aprovar = false;
    this.visibilidade.reprovar = false;
    this.visibilidade.editar = false;
    this.visibilidade.resumo = true;
    this.visibilidade.resumoFinanceiro = false;
    this.visibilidade.verJustificativa = false;
    this.visibilidade.vincularNota = false;
    this.visibilidade.imprimirNota = false;
    this.visibilidade.conferir = false;
    this.visibilidade.faturar = false;
    this.visibilidade.integrar = false;
    this.visibilidade.anexos = false;
    this.visibilidade.aguardarIntegracao = false;
    this.visibilidade.aguardarValidacao = false;
    this.visibilidade.verRecebimentos = false;
    this.visibilidade.podeEditarRecebimentos = false;
    this.visibilidade.tagsDoPedido = true;

    let etapa = this.etapas.find((p) => p.id === this.pedido.ordemEtapa);

    if (!etapa) return;

    switch (this.pedido.ordemEtapa) {
      // vendas
      case 0:
        this.visibilidade.editar =
          etapa.ordem === EtapaDoPedido.AguardandoValidacao ||
          etapa.ordem === EtapaDoPedido.PagamentoReprovado ||
          etapa.ordem === EtapaDoPedido.PedidoForaPrazo ||
          etapa.ordem === EtapaDoPedido.Editando;
        this.visibilidade.verJustificativa = etapa.ordem === EtapaDoPedido.PagamentoReprovado;
        this.visibilidade.anexos = true;

        this.visibilidade.tagsDoPedido =
          etapa.ordem !== EtapaDoPedido.AguardandoPagamentoFinanciamento &&
          etapa.ordem !== EtapaDoPedido.AguardandoPagamentoRecursoProprio;

        break;

      // integração
      case 1:
        this.visibilidade.integrar = etapa.ordem === EtapaDoPedido.AguardandoIntegracao;
        this.visibilidade.aguardarIntegracao =
          etapa.ordem === EtapaDoPedido.PedidoIntegrado ||
          etapa.ordem === EtapaDoPedido.AguardandoFaturamentoFinanciamento ||
          etapa.ordem === EtapaDoPedido.AguardandoPagamentoRecursoProprio;
        this.visibilidade.aguardarValidacao = etapa.ordem === EtapaDoPedido.AguardandoIntegracao;
        break;

      // financiamento
      case 2:
        this.visibilidade.faturar = etapa.ordem === EtapaDoPedido.AguardandoFaturamentoFinanciamento;
        this.visibilidade.imprimirNota = etapa.ordem === EtapaDoPedido.PedidoFaturadoFinanciamento;
        this.visibilidade.anexos = true;
        break;

      // financeiro
      case 3:
        this.visibilidade.resumoFinanceiro = true;
        this.visibilidade.aprovar = this.visibilidade.reprovar =
          etapa.ordem === EtapaDoPedido.AguardandoPagamentoRecursoProprio ||
          etapa.ordem === EtapaDoPedido.AguardandoPagamentoFinanciamento;
        this.visibilidade.verJustificativa = etapa.ordem === EtapaDoPedido.PagamentoReprovado;
        this.visibilidade.verRecebimentos =
          etapa.ordem === EtapaDoPedido.AguardandoPagamentoRecursoProprio ||
          etapa.ordem === EtapaDoPedido.AguardandoPagamentoFinanciamento ||
          etapa.ordem === EtapaDoPedido.PagamentoAprovado;
        this.visibilidade.podeEditarRecebimentos =
          etapa.ordem === EtapaDoPedido.AguardandoPagamentoRecursoProprio ||
          etapa.ordem === EtapaDoPedido.AguardandoPagamentoFinanciamento;
        break;

      // separação
      case 4:
        this.visibilidade.conferir = etapa.ordem === EtapaDoPedido.AguardandoSeparacao;
        // this.visibilidade.imprimirNota = etapa.ordem === EtapaDoPedido.NFeEmitida;
        // this.tipoNota = 1;
        break;

      // faturamento
      case 5:
        this.visibilidade.imprimirNota = true;
        this.visibilidade.vincularNota = etapa.ordem === EtapaDoPedido.AguardandoNFe;
        this.visibilidade.faturar = etapa.ordem === EtapaDoPedido.AguardandoFaturamentoSemFinanciamento;
        break;

      // expedição
      case 6:
        this.visibilidade.despachar = etapa.ordem === EtapaDoPedido.AguardandoTransporte;
        this.visibilidade.entregar = etapa.ordem === EtapaDoPedido.PedidoColetado;
        this.visibilidade.separar = etapa.ordem === EtapaDoPedido.AguardandoSeparacaoExpedicao;
        break;

      case 10:
        this.visibilidade.tagsDoPedido = false;
        this.visibilidade.anexos = true;
        break;

      default:
        break;
    }
  }

  buscarEtapas() {
    this.carregandoService.mostra('buscarEtapas');

    return new Promise((resolve, reject) => {
      this.etapaService.consultar().subscribe(
        (resp) => {
          this.etapas = resp;

          this.defineVisibilidade();

          this.carregandoService.esconde('buscarEtapas');
          resolve();
        },
        (erro) => {
          this.carregandoService.esconde('buscarEtapas');
          this.notificacaoService.erro(erro);
          reject();
        }
      );
    });
  }

  buscarPedido() {
    this.carregandoService.mostra('buscarPedido');

    return new Promise((resolve, reject) => {
      // this.pedidoService.consultarCompleto(this.ocorrencia.idCupom, false, false, false, false, false).subscribe(resp => {
      //   this.pedido = resp.venda;

      //   this.carregandoService.esconde('buscarPedido');
      //   resolve();
      // }, (erro) => {
      //   this.carregandoService.esconde('buscarPedido');
      //   this.notificacaoService.erro(erro);
      //   reject();
      // });

      this.pedidoService
        .bC_Pedido(
          this.ocorrencia.idCupom,
          false, // atualizarValores
          false, // buscarEstoque
          false // duplicando
        )
        .subscribe(
          (pedido) => {
            this.pedido = pedido;

            this.carregandoService.esconde('buscarPedido');
            resolve();
          },
          (erro) => {
            this.carregandoService.esconde('buscarPedido');
            this.notificacaoService.erro(erro);
            reject(erro);
          }
        );
    });
  }

  ocultarOcorrenciaHistorico(historico) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente ocultar este item do histórico? (Outros funcionários não poderão mais visualizar este item.)',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('ocultarOcorrenciaHistorico');

        this.ocorrenciaHistoricoService.ocultar(historico).subscribe(
          (result) => {
            this.novaMensagem = '';
            this.buscarHistorico();
            this.carregandoService.esconde('ocultarOcorrenciaHistorico');
          },
          (erro) => {
            this.carregandoService.esconde('ocultarOcorrenciaHistorico');
            this.notificacaoService.erro(erro);
          }
        );
      }
    });
  }

  mostrarOcorrenciaHistorico(historico) {
    this.carregandoService.mostra('mostrarOcorrenciaHistorico');

    this.ocorrenciaHistoricoService.mostrar(historico).subscribe(
      (result) => {
        this.novaMensagem = '';
        this.buscarHistorico();
        this.carregandoService.esconde('mostrarOcorrenciaHistorico');
      },
      (erro) => {
        this.carregandoService.esconde('mostrarOcorrenciaHistorico');
        this.notificacaoService.erro(erro);
      }
    );
  }

  toggleVisibilidadeHistorico(historico) {
    if (historico.idFuncionario !== this.usuarioLogado.id) return;

    if (historico.ocultar) {
      this.mostrarOcorrenciaHistorico(historico);
    } else {
      this.ocultarOcorrenciaHistorico(historico);
    }
  }

  // 0 - faturamento | 1- fiscal
  imprimirNota(pedido: Pedido, tipoNota) {
    this.carregandoService.mostra('imprimirNota');

    this.notaFiscalService.imprimirNotaPorIdCupom(pedido.idCupom, tipoNota).subscribe(
      (resp) => {
        // this.notificacaoService.sucesso('Documento gerado com sucesso!!!');
        this.utilitarioService.openBlob(resp);

        this.carregandoService.esconde('imprimirNota');
      },
      (erro) => {
        const reader = new FileReader();

        // This fires after the blob has been read/loaded.
        reader.addEventListener('loadend', (e) => {
          const text = e.srcElement['result'];
          this.carregandoService.esconde('imprimirNota');
          this.notificacaoService.erro(text);
        });

        // Start reading the blob as text.
        reader.readAsText(erro.error);
      }
    );
  }

  notasFiscais(pedido: Pedido) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(NotaFiscalPedidoModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: {
        idCupom: pedido.idCupom,
        filtraOcorrencia: true
      },
      panelClass: 'modal-card'
    });
  }

  baixarArquivo(anexo: OcorrenciaAnexo) {
    this.carregandoService.mostra('baixarArquivo');
    this.arquivoService.baixarArquivo(anexo.id, TipoArquivo.Ocorrencia).subscribe(
      (arq) => {
        this.utilitarioService.saveBlob(arq, anexo.arquivo);
        this.carregandoService.esconde('baixarArquivo');
      },
      (erro) => {
        this.carregandoService.esconde('baixarArquivo');
        this.notificacaoService.erro(erro);
      }
    );
  }

  verLogOcorrencia() {
    const dialogRef = this.dialog.open(LogOcorrenciaComponent, {
      width: '1200px',
      data: {
        idOcorrencia: this.idOcorrencia
      },
      panelClass: 'modal-card',
      maxHeight: '100vh'
    });
  }

  verLogEtapaOcorrencia() {
    const dialogRef = this.dialog.open(LogEtapaOcorrenciaModalComponent, {
      width: '1200px',
      data: {
        idOcorrencia: this.idOcorrencia,
        vendedor: this.vendedor,
        etapas: this.etapasOcorrencia,
        duracao:
          this.ocorrencia.status === StatusDaOcorrencia.EmAndamento ||
          this.ocorrencia.status === StatusDaOcorrencia.Concluido
            ? this.ocorrencia.dataStatus
            : Date.now(),
        concluido: this.ocorrencia.status === StatusDaOcorrencia.Concluido
      },
      panelClass: 'modal-card',
      maxHeight: '100vh'
    });
  }

  verificarSeExisteLog(idOcorrencia) {
    this.carregandoService.mostra('verificarSeExisteLog');

    this.ocorrenciaService.verificarSeExiste(idOcorrencia).subscribe(
      (existe) => {
        this.existeLog = existe;
        this.carregandoService.esconde('verificarSeExisteLog');
      },
      (erro) => {
        this.carregandoService.esconde('verificarSeExisteLog');
        this.notificacaoService.erro(erro);
      }
    );
  }

  adicinarNota() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(CadastrarNotaFiscalPedidoModalComponent, {
      width: largura > 830 ? '900px' : $('body').width().toString() + 'px',
      data: {
        ocorrencia: true,
        idOcorrencia: this.idOcorrencia
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarNotasOcorrencia();
      }
    });
  }

  buscarNotasOcorrencia(seguirPaginacao?) {
    // if (!seguirPaginacao) {
    //   this.paginator.firstPage();
    //   this.paginacao.paginaAtual = 1;
    //   this.paginacao.total = 0;
    // }

    this.carregandoService.mostra('buscarNotasOcorrencia');
    this.ocorrenciaService
      .consultarNotaFiscalOcorrenciaComPaginacao(
        this.paginacao.paginaAtual,
        this.itensPorPagina,
        this.campoOrdenacao,
        this.ordenarDesc,
        this.idOcorrencia
      )
      .subscribe(
        (data) => {
          this.notasFiscaisOcorrencia = data.itens;
          this.paginacao.total = data.total;
          this.carregandoService.esconde('buscarNotasOcorrencia');
        },
        (erro) => {
          console.error(erro);
          this.carregandoService.esconde('buscarNotasOcorrencia');
          this.notificacaoService.erro('Não foi possível buscar as notas da ocorrência');
        }
      );
  }

  ordena(campo: string) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({
        length: this.paginator.length,
        pageIndex: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize
      });
    }

    return false;
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize) this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarNotasOcorrencia(true);
  }
}
